import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "educaser-cookie-consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, choice);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-3xl rounded-2xl border border-white/10 bg-brand-blue p-5 text-white shadow-[0_20px_60px_rgba(0,35,102,0.45)] sm:inset-x-6 sm:bottom-6 sm:p-6"
          data-testid="cookie-consent"
        >
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-start gap-3">
              <Cookie className="mt-0.5 h-6 w-6 shrink-0 text-brand-red-light" />
              <p className="text-sm leading-relaxed text-white/85">
                Nous utilisons des cookies pour assurer le bon fonctionnement du site et mesurer son
                audience. Consultez notre{" "}
                <Link to="/cookies" className="font-semibold text-white underline underline-offset-2 hover:text-brand-red-light">
                  politique cookies
                </Link>.
              </p>
            </div>
            <div className="flex shrink-0 gap-3">
              <button
                onClick={() => decide("refused")}
                className="rounded-full border border-white/30 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-white/10"
                data-testid="cookie-refuse"
              >
                Refuser
              </button>
              <button
                onClick={() => decide("accepted")}
                className="rounded-full bg-brand-red px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-brand-red-light"
                data-testid="cookie-accept"
              >
                Tout accepter
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
